export default __webpack_public_path__ + "static/media/247.79040945.jpg";